import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { MapContainer, TileLayer } from 'react-leaflet';
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader';
import { WorldMapTitle } from '../../../../Utils/Constants';
import { worldMapProps, worldMapSubheading } from '../../../../Data/MiscellaneousData/MapsData';

const MapContainerAny = MapContainer as any;
const TileLayerAny = TileLayer as any;

export default function WorldMap() {

    return (
        <Col sm={6}>
            <Card>
                <CommonCardHeader title={WorldMapTitle} subTitle={worldMapSubheading} />
                <CardBody>
                    <MapContainerAny
                        className="jvector-map-height custom-map"
                        {...worldMapProps}>
                        <TileLayerAny url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" />
                    </MapContainerAny>
                </CardBody>
            </Card>
        </Col>
    );
}
